import _ from 'lodash';
import mongoose from 'mongoose';
import { peopleCountMatrix } from '../constants';
import { IServiceDocument } from '../schemas/service';
import { IServicePricingElement } from '../schemas/service-pricing';

export function preSave(this: IServiceDocument) {
  if (this.isNew || this.isModified('pricing')) sortPricing(this);
}

function sortPricing(service: IServiceDocument) {
  const sortedPricing = _.sortBy(service.pricing, ({ adults, children, infants }) => {
    const peopleCount = { adultCount: adults, childrenCount: children, infantCount: infants };
    return _.findIndex(peopleCountMatrix, peopleCount);
  }) as mongoose.Types.Array<IServicePricingElement>;
  service.pricing = sortedPricing;
}
